import React from "react";
import { COLORS } from "../../../helper/colors";

import Select from "react-select";
import clsx from "clsx";

const customStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: !state.isDisabled ? COLORS.white : COLORS.gray50,
    boxShadow: "none",
    borderColor: state.isFocused && COLORS.textGray,
    outline: state.isFocused && COLORS.textGray,
    textAlign: "left",
    padding: 6,
    borderRadius: 8,
    "&:hover": {
      borderColor: COLORS.textGray,
      outline: COLORS.textGray,
    },
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? COLORS.primary : COLORS.white,
      textAlign: "left",
      color: COLORS.black,
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: isSelected ? COLORS.primary : COLORS.textGray,
      },
    };
  },
  menu: (base) => ({ ...base, zIndex: 9999 }),
};

export const Dropdown = ({ errorMessage, error, label, ...rest }) => {
  return (
    <div className="flex w-full flex-col items-start my-3 relative">
      <div
        className={clsx(
          "invisible bottom-10 left-2 text-textGray absolute px-2 bg-white z-10",
          !!rest.value &&
            rest.value !== null &&
            rest.isDisabled &&
            "bg-slate-200 rounded-lg"
        )}
        style={{
          visibility: !!rest.value && rest.value !== null && "visible",
        }}
      >
        {label}
      </div>
      <Select styles={customStyles} className="w-full" {...rest} />
      {!!error && (
        <div className="text-sm text-left text-red-500 pl-1">
          {errorMessage}
        </div>
      )}
    </div>
  );
};
